<template>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      background-color="#545c64"
      text-color="#fff"
      router
      active-text-color="#ffd04b">

      <el-menu-item index="admin" v-if="isadmin">
        <i class="el-icon-star-off"></i>
        <span slot="title">账号管理</span>
      </el-menu-item>

      <el-menu-item index="xy" v-if="isadmin">
        <i class="el-icon-star-off"></i>
        <span slot="title">人员管理</span>
      </el-menu-item>

      <el-menu-item index="text" v-if="isadmin">
        <i class="el-icon-edit-outline"></i>
        <span slot="title">文章管理</span>
      </el-menu-item>

      <el-menu-item index="exam" v-if="isadmin">
        <i class="el-icon-tickets"></i>
        <span slot="title">考卷管理</span>
      </el-menu-item>

      <el-menu-item index="home" v-if="!isadmin">
        <i class="el-icon-star-off"></i>
        <span slot="title">首页</span>
      </el-menu-item>


      <el-menu-item index="sh" v-if="!isadmin">
        <i class="el-icon-edit-outline"></i>
          <span slot="title">学习审核</span>
      </el-menu-item>

      <el-menu-item index="yh" v-if="!isadmin">
        <i class="el-icon-search"></i>
        <span slot="title">隐患排查</span>
      </el-menu-item>

      <el-menu-item index="sexam" v-if="!isadmin">
        <i class="el-icon-tickets"></i>
        <span slot="title">考试审核</span>
      </el-menu-item>

      <el-submenu index="xx" v-if="!isadmin">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>信息管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="dw">单位管理</el-menu-item>
          <el-menu-item index="cl">车辆管理</el-menu-item>
          <el-menu-item index="ry">人员管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="nl" v-if="!isadmin">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>内容管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="text">文章管理</el-menu-item>
          <el-menu-item index="info">通知管理</el-menu-item>
          <el-menu-item index="exam">考卷管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="gx" v-if="!isadmin">
        <template slot="title">
          <i class="el-icon-download"></i>
          <span>共享文库</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="textall">共享文章</el-menu-item>
          <el-menu-item index="examall">共享考卷</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
</template>

<script>
  export default {
    data() {
      return {
        isadmin:(this.$store.getters.name == 'admin'),
      };
    },
    computed:{
      activeIndex(){
        return this.$store.state.activeIndex;
      }
    },
    methods: {
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/Slider.vue